import * as React from "react";
const SvgDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 9, viewBox: "0 0 16 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M 16 0 L 9.4142 6.5858 C 8.6332 7.3668 7.3668 7.3668 6.5858 6.5858 L 0 0 L 0 -1 H 16 Z", fill: "currentColor" }));
export default SvgDown;
